{{#if preview}}
  <em>Group Break</em>
{{else}}
  <div class="form-builder-group-break" data-behavior="form-group-break"></div>
{{/if}}
